import { handleActions } from 'redux-actions';

import * as paths from '../../config/paths';

import { createRoute } from '../../lib/router';

import * as constants from './constants';

export const initialState = {
  breadcrumbs: [],
};

export const getBreadcrumbs = state => state.breadcrumbs;

function clearBreadcrumbs(state, { quantity }) {
  const breadcrumbs = quantity ? state.breadcrumbs.slice(0, quantity) : [];

  return {
    ...state,
    breadcrumbs,
  };
}

function popBreadcrumbs(state, { quantity }) {
  const breadcrumbs = state.breadcrumbs.slice(0, -(quantity || 1));

  return {
    ...state,
    breadcrumbs,
  };
}

function pushBreadcrumbs(state, { breadcrumbs }) {
  return {
    ...state,
    breadcrumbs: state.breadcrumbs.concat(breadcrumbs),
  };
}

function pushLocationBreadcrumb(
  state,
  { organizationId, locationId, locationName }
) {
  const breadcrumbs = [
    {
      name: locationName,
      route: createRoute(paths.LOCATION, { organizationId, locationId }),
    },
  ];

  return pushBreadcrumbs(state, { breadcrumbs });
}

function pushOrganizationBreadcrumb(
  state,
  { organizationId, organizationName }
) {
  const breadcrumbs = [
    {
      name: organizationName,
      route: createRoute(paths.ORGANIZATION_LOCATIONS, {
        organizationId,
      }),
    },
  ];

  return pushBreadcrumbs(state, { breadcrumbs });
}

function setLocationBreadcrumb(
  state,
  { organizationId, organizationName, locationId, locationName }
) {
  const withOrganization = pushOrganizationBreadcrumb(state, {
    organizationId,
    organizationName,
  });
  return pushLocationBreadcrumb(withOrganization, {
    organizationId,
    locationId,
    locationName,
  });
}

function setOrganizationBreadcrumb(
  state,
  { organizationId, organizationName }
) {
  return pushOrganizationBreadcrumb(state, {
    organizationId,
    organizationName,
  });
}

export default handleActions(
  {
    [constants.CLEAR_BREADCRUMBS]: clearBreadcrumbs,
    [constants.POP_BREADCRUMBS]: popBreadcrumbs,
    [constants.PUSH_BREADCRUMBS]: pushBreadcrumbs,
    [constants.PUSH_LOCATION_BREADCRUMB]: pushLocationBreadcrumb,
    [constants.PUSH_ORGANIZATION_BREADCRUMB]: pushOrganizationBreadcrumb,
    [constants.SET_LOCATION_BREADCRUMB]: setLocationBreadcrumb,
    [constants.SET_ORGANIZATION_BREADCRUMB]: setOrganizationBreadcrumb,
  },
  initialState
);
